var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 40,
    viewBox: "0 0 149 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3971_1644",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 0,
    width: 22,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6172 0L32.2301 0V14.2183L11.6172 14.2183L11.6172 0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3971_1644)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3971_1644",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 21,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0859 8.05817C13.3962 9.95395 14.4283 11.946 15.0835 14.1232C16.4889 10.9018 19.0179 8.24701 22.1106 6.73261C25.2984 8.24701 27.7323 10.9018 29.1377 14.1232C29.7929 11.946 30.825 9.85768 32.1352 8.05817C29.7014 4.6443 26.1402 2.08574 22.0191 0.66391C18.081 2.08574 14.615 4.6443 12.0859 8.05817Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3971_1644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0859 14.1232L32.1352 14.1232V0.66391L12.0859 0.66391L12.0859 14.1232Z",
    fill: "url(#paint0_linear_3971_1644)"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.186657 32.7039C0.373316 31.3784 0.373316 30.0491 0.186657 28.8161C2.43388 30.9044 7.58711 31.9449 11.9901 31.9449C15.5512 31.9449 17.0518 31.1858 17.0518 29.5752C17.0518 27.4906 14.8009 27.3017 9.46101 26.8278C3.55749 26.3538 0 25.4059 0 21.8032C0 18.2005 3.18417 16.5898 9.74283 16.5898C13.3955 16.5898 16.9566 17.0638 20.4226 18.0117C20.236 19.2447 20.236 20.4777 20.4226 21.707C16.9566 20.2851 13.304 19.4335 9.55617 19.4335C5.80837 19.4335 4.30778 20.1926 4.30778 21.707C4.30778 23.6027 6.27684 24.0767 11.1483 24.4581C17.3336 24.932 21.3596 25.7836 21.3596 29.5752C21.3596 33.0816 18.0802 34.696 11.6167 34.696C7.68227 34.696 3.8393 34.0295 0.186657 32.7039Z",
    fill: "#004433"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.764 20.1899C28.6688 24.9293 28.764 29.765 28.9507 34.5045H24.7344C24.921 28.6246 24.921 22.7484 24.7344 16.9648C26.7034 17.1574 28.6688 17.1574 30.6379 16.9648C34.3857 21.8006 38.225 26.6363 42.2546 31.3757C42.3498 26.54 42.2546 21.708 42.068 16.9648C43.4734 17.1574 44.974 17.1574 46.3794 16.9648C46.1891 22.8447 46.1891 28.7209 46.4709 34.5045H40.6626C36.8196 29.5725 32.8851 24.8331 28.764 20.1899Z",
    fill: "#004433"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8124 31.7549C56.7778 31.8512 58.1832 31.8512 61.1808 31.8512C65.4922 31.8512 66.6158 30.6182 66.6158 29.1963C66.6158 27.7745 65.4922 26.9192 61.3711 26.9192H54.7173C54.7173 28.5336 54.7173 30.2368 54.8124 31.7549ZM61.3711 24.6457C64.2734 24.6457 65.774 23.7941 65.774 22.0872C65.774 20.3802 64.1819 19.6212 61.3711 19.6212H54.7173C54.7173 21.1393 54.6221 22.8462 54.7173 24.6457C56.7778 24.5495 59.0287 24.6457 61.3711 24.6457ZM50.501 16.8738C53.7803 16.8738 56.7778 16.7775 61.3711 16.7775C66.9928 16.7775 70.0818 18.1068 70.0818 21.1393C70.0818 23.8867 67.5528 25.0234 64.4601 25.1197V25.4048C68.3031 25.4974 71.2091 26.7303 71.2091 29.7628C71.2091 34.0283 65.3055 34.5023 60.9941 34.5023C55.936 34.5023 53.7803 34.4097 50.501 34.4097C50.7828 30.048 50.7828 21.2319 50.501 16.8738Z",
    fill: "#004433"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1642 37.3496C87.7909 37.3496 87.4139 37.4422 87.1321 37.7273C86.8539 37.9161 86.7588 38.2975 86.7588 38.6752C86.7588 39.0528 86.8539 39.4305 87.1321 39.6231C87.4139 39.9045 87.7909 40.0007 88.1642 40.0007C88.5375 40.0007 88.9145 39.9045 89.1012 39.6231C89.383 39.338 89.5696 39.0528 89.4745 38.6752C89.4745 38.2975 89.2878 38.0087 89.1012 37.7273C88.9145 37.4422 88.5375 37.3496 88.1642 37.3496Z",
    fill: "#004433"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4171 37.3496C84.0438 37.3496 83.6669 37.4422 83.385 37.7273C83.1069 37.9161 83.0117 38.2975 83.0117 38.6752C83.0117 39.0528 83.1069 39.4305 83.385 39.6231C83.6669 39.9045 84.0438 40.0007 84.4171 40.0007C84.7905 40.0007 85.1674 39.9045 85.3541 39.6231C85.6359 39.338 85.7274 39.0528 85.7274 38.6752C85.7274 38.2975 85.6359 38.0087 85.3541 37.7273C85.0723 37.4422 84.699 37.3496 84.4171 37.3496Z",
    fill: "#004433"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.148 26.7296V32.5131H117.306C114.495 32.5131 113.837 30.5211 113.837 29.7621C113.745 28.0551 115.242 26.2556 118.148 26.7296ZM123.675 21.3273C122.082 20.0943 120.117 19.5278 118.148 19.6204C113.463 19.6204 111.963 22.2752 111.685 22.8417L113.65 23.6971C114.682 22.2752 116.274 21.5162 117.961 21.705C122.459 21.705 123.019 24.6449 123.019 26.1593V31.1839C123.019 32.0392 122.269 32.702 121.427 32.6057H120.49V25.5928C119.458 25.1189 118.335 24.8338 117.306 24.8338C114.118 24.8338 111.589 26.1593 111.589 29.9509C111.589 30.8988 111.963 31.8467 112.526 32.6057L107 32.6057V15.4512L104.467 16.3991V30.3323C104.467 31.5653 103.999 32.5131 101.565 32.5131H98.6587C98.2854 32.5131 97.8169 32.5131 96.9714 31.1839L91.2582 21.1385L90.3213 19.5278C88.0704 20.8534 86.5735 23.2231 86.3868 25.7817C86.4783 27.2035 86.9468 28.5291 87.6971 29.6695L89.6662 32.5131H82.262C80.2966 32.5131 79.3597 31.469 79.3597 29.1955C79.4512 27.8663 79.8282 26.5407 80.67 25.4966L79.1694 24.5487C78.0458 25.9705 77.3906 27.7737 77.3906 29.6695C77.3906 32.6057 79.1694 34.4089 82.4487 34.4089H93.5055L90.1346 29.4769C88.8207 27.3923 87.8838 25.4966 89.6662 23.0343C90.6031 24.6449 95.006 32.228 95.2879 32.6057C96.0345 33.8387 97.3484 34.5015 98.7539 34.4089H101.751C102.315 34.4089 102.875 34.4089 103.439 34.2164C103.812 34.1238 104.189 34.0275 104.562 33.8387V34.3127L122.269 34.3127C124.052 34.4089 125.644 32.9871 125.739 31.1839V25.9705C125.739 24.3598 124.988 22.5603 123.675 21.3273Z",
    fill: "#004433"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M131.547 19.6192L136.327 17.8197V16.5867L133.984 17.4383L133.703 16.7756C133.607 16.4904 133.703 16.209 134.076 16.0165C134.171 15.9239 134.358 15.9239 134.544 15.9239C134.731 15.9239 134.826 16.0165 134.921 16.1128L135.2 16.3016L135.481 15.2612L135.295 15.1649C134.731 14.7872 133.984 14.6909 133.326 14.976C132.857 15.1649 132.389 15.45 132.202 15.9239C132.015 16.3979 132.015 16.8718 132.297 17.3458L132.579 18.0085L132.111 18.1974L131.547 19.6192Z",
    fill: "#004433"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M139.603 30.5211C139.512 31.7541 138.483 32.702 137.261 32.6057H135.672V19.3353L133.14 20.2832V32.6057H129.86L129.019 34.5015H137.638C139.512 34.5015 142.041 32.8908 142.041 30.3323V15.4512L139.512 16.3991V30.5211H139.603Z",
    fill: "#004433"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M146.352 16.4903V34.4076H148.789V15.6387L146.352 16.4903Z",
    fill: "#004433"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3971_1644",
    x1: 22.1113,
    y1: 14.1247,
    x2: 22.1113,
    y2: 0.664648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82C341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0078125,
    stopColor: "#82C341"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0117188,
    stopColor: "#81C241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.015625,
    stopColor: "#80C241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0195313,
    stopColor: "#80C241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0234375,
    stopColor: "#7FC141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0273438,
    stopColor: "#7FC141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#7EC142"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0351563,
    stopColor: "#7EC042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0390625,
    stopColor: "#7DC042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0429688,
    stopColor: "#7DC042"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#7CBF42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0507813,
    stopColor: "#7CBF42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0546875,
    stopColor: "#7BBF42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0585938,
    stopColor: "#7BBE42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#7ABE42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0664063,
    stopColor: "#7ABE42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0703125,
    stopColor: "#79BD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0742188,
    stopColor: "#79BD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.078125,
    stopColor: "#78BD42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0820313,
    stopColor: "#78BC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0859375,
    stopColor: "#77BC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0898438,
    stopColor: "#77BC43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#76BB43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0976563,
    stopColor: "#75BB43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101563,
    stopColor: "#75BB43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.105469,
    stopColor: "#74BA43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109375,
    stopColor: "#74BA43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.113281,
    stopColor: "#73BA43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.117188,
    stopColor: "#73B943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121094,
    stopColor: "#72B943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#72B943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128906,
    stopColor: "#71B843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.132813,
    stopColor: "#71B843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.136719,
    stopColor: "#70B844"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.140625,
    stopColor: "#70B744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.144531,
    stopColor: "#6FB744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.148438,
    stopColor: "#6FB744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152344,
    stopColor: "#6EB644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#6EB644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.160156,
    stopColor: "#6DB644"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164063,
    stopColor: "#6DB544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.167969,
    stopColor: "#6CB544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171875,
    stopColor: "#6CB544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175781,
    stopColor: "#6BB544"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.179688,
    stopColor: "#6BB444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183594,
    stopColor: "#6AB444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#6AB445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191406,
    stopColor: "#69B345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195313,
    stopColor: "#69B345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.199219,
    stopColor: "#68B345"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203125,
    stopColor: "#68B245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207031,
    stopColor: "#67B245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.210938,
    stopColor: "#67B245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.214844,
    stopColor: "#66B145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#66B145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.222656,
    stopColor: "#65B145"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.226563,
    stopColor: "#65B045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.230469,
    stopColor: "#64B045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#64B045"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.238281,
    stopColor: "#63AF46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.242188,
    stopColor: "#63AF46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246094,
    stopColor: "#62AF46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#62AE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253906,
    stopColor: "#61AE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257813,
    stopColor: "#61AE46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.261719,
    stopColor: "#60AD46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265625,
    stopColor: "#60AD46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.269531,
    stopColor: "#5FAD46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.273438,
    stopColor: "#5FAC46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.277344,
    stopColor: "#5EAC46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#5EAC46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285156,
    stopColor: "#5DAB46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289063,
    stopColor: "#5DAB46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.292969,
    stopColor: "#5CAB47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.296875,
    stopColor: "#5CAA47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.300781,
    stopColor: "#5BAA47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304688,
    stopColor: "#5BAA47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.308594,
    stopColor: "#5AA947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#5AA947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.316406,
    stopColor: "#59A947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.320313,
    stopColor: "#58A947"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.324219,
    stopColor: "#58A847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#57A847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332031,
    stopColor: "#57A847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#56A747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.339844,
    stopColor: "#56A747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#55A748"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.347656,
    stopColor: "#55A648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351563,
    stopColor: "#54A648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355469,
    stopColor: "#54A648"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.359375,
    stopColor: "#53A548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.363281,
    stopColor: "#53A548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367188,
    stopColor: "#52A548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371094,
    stopColor: "#52A448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#51A448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378906,
    stopColor: "#51A448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382813,
    stopColor: "#50A348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.386719,
    stopColor: "#50A348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.390625,
    stopColor: "#4FA348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394531,
    stopColor: "#4FA248"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.398438,
    stopColor: "#4EA249"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.402344,
    stopColor: "#4EA249"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#4DA149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.410156,
    stopColor: "#4DA149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414063,
    stopColor: "#4CA149"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417969,
    stopColor: "#4CA049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421875,
    stopColor: "#4BA049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425781,
    stopColor: "#4BA049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429688,
    stopColor: "#4A9F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433594,
    stopColor: "#4A9F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#499F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441406,
    stopColor: "#499E49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.445313,
    stopColor: "#489E49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.449219,
    stopColor: "#489E4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.453125,
    stopColor: "#479D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457031,
    stopColor: "#479D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.460938,
    stopColor: "#469D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464844,
    stopColor: "#469C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#459C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472656,
    stopColor: "#459C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476563,
    stopColor: "#449C4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.480469,
    stopColor: "#449B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#439B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488281,
    stopColor: "#439B4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492188,
    stopColor: "#429A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496094,
    stopColor: "#429A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#419A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503906,
    stopColor: "#41994B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.507813,
    stopColor: "#40994B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511719,
    stopColor: "#40994B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#3F984B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519531,
    stopColor: "#3F984B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523438,
    stopColor: "#3E984B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527344,
    stopColor: "#3E974B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#3D974B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535156,
    stopColor: "#3D974B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539063,
    stopColor: "#3C964B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542969,
    stopColor: "#3C964B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#3B964B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550781,
    stopColor: "#3A954B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.554688,
    stopColor: "#3A954C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.558594,
    stopColor: "#39954C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#39944C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566406,
    stopColor: "#38944C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570313,
    stopColor: "#38944C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574219,
    stopColor: "#37934C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#37934C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582031,
    stopColor: "#36934C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.585938,
    stopColor: "#36924C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589844,
    stopColor: "#35924C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#35924C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.597656,
    stopColor: "#34914C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.601563,
    stopColor: "#34914C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605469,
    stopColor: "#33914C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609375,
    stopColor: "#33904D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613281,
    stopColor: "#32904D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.617187,
    stopColor: "#32904D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621094,
    stopColor: "#318F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#318F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.628906,
    stopColor: "#308F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632813,
    stopColor: "#308F4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636719,
    stopColor: "#2F8E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#2F8E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644531,
    stopColor: "#2E8E4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.648438,
    stopColor: "#2E8D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.652344,
    stopColor: "#2D8D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#2D8D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.660156,
    stopColor: "#2C8C4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664063,
    stopColor: "#2C8C4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667969,
    stopColor: "#2B8C4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#2B8B4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675781,
    stopColor: "#2A8B4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679688,
    stopColor: "#2A8B4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.683594,
    stopColor: "#298A4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#298A4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.691406,
    stopColor: "#288A4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.695313,
    stopColor: "#28894E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.699219,
    stopColor: "#27894E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#27894E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.707031,
    stopColor: "#26884E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.710938,
    stopColor: "#26884E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714844,
    stopColor: "#25884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#25874F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722656,
    stopColor: "#24874F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726563,
    stopColor: "#24874F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.730469,
    stopColor: "#23864F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734375,
    stopColor: "#23864F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738281,
    stopColor: "#22864F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742188,
    stopColor: "#22854F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746094,
    stopColor: "#21854F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#21854F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753906,
    stopColor: "#20844F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757813,
    stopColor: "#20844F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.761719,
    stopColor: "#1F844F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#1F8350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769531,
    stopColor: "#1E8350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773438,
    stopColor: "#1D8350"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.777344,
    stopColor: "#1D8250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#1C8250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785156,
    stopColor: "#1C8250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789063,
    stopColor: "#1B8250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792969,
    stopColor: "#1B8150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.796875,
    stopColor: "#1A8150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800781,
    stopColor: "#1A8150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804687,
    stopColor: "#198050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808594,
    stopColor: "#198050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#188050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.816406,
    stopColor: "#187F51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.820313,
    stopColor: "#177F51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824219,
    stopColor: "#177F51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828125,
    stopColor: "#167E51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832031,
    stopColor: "#167E51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.835938,
    stopColor: "#157E51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.839844,
    stopColor: "#157D51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#147D51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847656,
    stopColor: "#147D51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.851563,
    stopColor: "#137C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855469,
    stopColor: "#137C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859375,
    stopColor: "#127C51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.863281,
    stopColor: "#127B51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.867188,
    stopColor: "#117B51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.871094,
    stopColor: "#117B52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#107A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878906,
    stopColor: "#107A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.882813,
    stopColor: "#0F7A52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.886719,
    stopColor: "#0F7952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.890625,
    stopColor: "#0E7952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.894531,
    stopColor: "#0E7952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898438,
    stopColor: "#0D7852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902344,
    stopColor: "#0D7852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#0C7852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.910156,
    stopColor: "#0C7752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914063,
    stopColor: "#0B7752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917969,
    stopColor: "#0B7752"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921875,
    stopColor: "#0A7653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925781,
    stopColor: "#0A7653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929688,
    stopColor: "#097653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933594,
    stopColor: "#097653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#087553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941406,
    stopColor: "#087553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.945313,
    stopColor: "#077553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.949219,
    stopColor: "#077453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.953125,
    stopColor: "#067453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957031,
    stopColor: "#067453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.960938,
    stopColor: "#057353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964844,
    stopColor: "#057353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#047353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972656,
    stopColor: "#047253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.976563,
    stopColor: "#037254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.980469,
    stopColor: "#037254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.984375,
    stopColor: "#027154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988281,
    stopColor: "#027154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.992187,
    stopColor: "#017154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996094,
    stopColor: "#007054"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007054"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnb);
export default __webpack_public_path__ + "static/media/snb.7561c37f2b3549c1b601d61ab45b495e.svg";
export { ForwardRef as ReactComponent };